import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircularCheckmark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 24,
		height: 24,
		rx: 12,
		fill: "#4B6EFA"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.2695 16.4697C11.2469 16.4958 11.2233 16.5213 11.1985 16.5461C10.6522 17.0924 9.76652 17.0924 9.22024 16.5461L5.75834 13.0842C5.21206 12.5379 5.21206 11.6522 5.75834 11.106C6.30461 10.5597 7.1903 10.5597 7.73657 11.106L10.2329 13.6023L16.2263 7.60892C16.7726 7.06265 17.6583 7.06265 18.2046 7.60892C18.7508 8.1552 18.7508 9.04088 18.2046 9.58716L11.5232 16.2685C11.445 16.3468 11.3597 16.4138 11.2695 16.4697Z",
		fill: "white"
	})]
});
export { SvgCircularCheckmark as ReactComponent };
